import { type QueryKey, type QueryFunction, parseQueryArgs } from "@tanstack/query-core";
import { type UseQueryOptions, type UseQueryResult, useQuery } from "@tanstack/react-query";


export const noRefetchDefaults = {
	cacheTime: 0,
	refetchInterval: false,
	refetchIntervalInBackground: false,
	refetchOnReconnect: false,
	refetchOnWindowFocus: false,
	refetchOnMount: true,
} as const;
/**
 * Same as useQuery, but automatically refetch only on component mount.
 */

export function useQueryNoRefetch<TQueryFnData, TError, TData = TQueryFnData, TQueryKey extends QueryKey = QueryKey>(
	arg1: TQueryKey | UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
	arg2?: QueryFunction<TQueryFnData, TQueryKey> | UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
	arg3?: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>
): UseQueryResult<TData, TError> {
	const parsedOptions = parseQueryArgs(arg1, arg2, arg3);
	return useQuery({
		...noRefetchDefaults,
		// Overriding defaults
		...parsedOptions,
	});
}
